module.exports = __webpack_public_path__ + "media/bgm.978189a9.mp3";